import { memo, useEffect } from 'react';
import { AbsoluteFill } from 'remotion';
import { v4 as uuidv4 } from 'uuid';
import Loader from '@/components/atoms/Loader';
import useAnalytics from '@/hooks/useAnalytics';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

function BufferingPoster({ clipId }: { clipId: string }) {
  const { trackPlayerBuffering } = useAnalytics();

  useEffect(() => {
    const bufferStateId = clipId + '-' + uuidv4();

    const useNewVideoTag = featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_New_Video_Tag_In_Preview] || false;

    trackPlayerBuffering({
      state: 'Buffering',
      clipId,
      bufferStateId,
      useNewVideoTag
    });

    return () => {
      trackPlayerBuffering({
        state: 'Loaded',
        clipId,
        bufferStateId,
        useNewVideoTag
      });
    };
  }, []);

  return (
    <AbsoluteFill
      className="absolute inset-0 overflow-hidden"
      data-testid="composite-player-loader"
      id="composite-player-loader"
    >
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden bg-gray-200/20">
        <Loader />
      </div>
    </AbsoluteFill>
  );
}

export default memo(BufferingPoster);
